export default "__VITE_ASSET__Dpc0LY_h__"